class InstallationTypeAPI {

  static all(slugs) {

    let url = `/wp-json/barth/v1/installation_types`

    // when we want to fetch only certain branches
    if (slugs) {
      let cleanSlugs = slugs.replace(/\s+/g, '') //remove all whitespace
      url = `/wp-json/barth/v1/installation_types?slug=${cleanSlugs}`
    }

    return fetch(url, {
      credentials: 'same-origin'
    })
    .then(this.handleStatus)
  }

  static handleStatus(response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Request rejected with status ${response.status}`)
    }
    return response
  }

}

export default InstallationTypeAPI



// WEBPACK FOOTER //
// ./src/js/projects/api/BranchAPI.js